import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";
import ptBR from "date-fns/locale/pt-BR";

interface IDateProps {
    id?: string;
    name: string;
    label: string;
    control: any;
    error: any;
    noDateForward?: boolean;
    format?: string;
    view?: any;
    placeHolder?: string;
    disabled?: boolean;
    onChange?: (value: string | number) => void;
}

export default function DatePickerMui({
    id,
    name,
    label,
    control,
    error,
    noDateForward,
    format,
    view,
    placeHolder,
    disabled,
    onChange,
}: IDateProps) {
    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                <Controller
                    name={name}
                    control={control}
                    render={({ field: { onChange: renderChange, value } }) => (
                        <DateTimePicker
                            disabled={disabled}
                            disableFuture={noDateForward}
                            inputFormat={format ? format : "dd/MM/yyyy"}
                            label={label}
                            openTo="day"
                            views={view ? view : ["year", "month", "day"]}
                            value={value}
                            onChange={(value: any) => {
                                renderChange(value || "");
                                if (typeof onChange === "function") onChange(value || "");
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    id={id}
                                    disabled={disabled}
                                    size="small"
                                    margin="normal"
                                    label={label}
                                    error={!!error && !!error[name]}
                                    helperText={!!error && error[name]?.message}
                                    fullWidth
                                    inputProps={{
                                        ...params.inputProps,
                                        placeholder: format === "MM/yyyy" ? "mm/aaaa" : "dd/mm/aaaa",
                                    }}
                                />
                            )}
                        />
                    )}
                />
            </LocalizationProvider>
        </>
    );
}
